import { useReducer } from 'react';
import { TemplatesListReducer } from './TemplatesListReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  TemplateListDispatchContext,
  TemplateListStateContext,
} from './UseTemplatesListContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface ITemplateListProviderProps {
  children: any;
  value?: IValue;
}

export function TemplatesListProvider({
  children,
  value = { initialState: defaultContextValues, reducer: TemplatesListReducer },
}: ITemplateListProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <TemplateListStateContext.Provider value={state}>
      <TemplateListDispatchContext.Provider value={dispatch}>{children}</TemplateListDispatchContext.Provider>
    </TemplateListStateContext.Provider>
  );
}
